import { useMutation } from '@tanstack/react-query'
import { postQuoteEstimate } from 'services/WalletsService'

export const usePostQuoteEstimateMutation = () => {
  return useMutation({ mutationFn: postQuoteEstimate })
}
